import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { Opin } from './pages/opin/opin.component'
// import { NotFoundComponent } from './pages/not-found/not-found.component'
import { ParceirosInsuranceComponent } from './pages/parceiros-insurance/parceiros-insurance.component'
import { ProdutosInsuranceComponent } from './pages/produtos-insurance/produtos-insurance.component'
// import { FormulaeComponent } from './pages/formulae/formulae.component'

const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import(
				'./pages/parceiros-insurance/parceiros-insurance.component'
			).then((m) => m.ParceirosInsuranceComponent),
		data: { title: 'Seguro Allianz - Faça sua cotação' },
	},
    // PAGINAS DE PRODUTOS:
	{
		path: 'auto',
		loadComponent: () =>
			import(
				'./pages/produtos-insurance/produtos-insurance.component'
			).then((m) => m.ProdutosInsuranceComponent),
		data: { title: 'Seguro Allianz - Auto! Faça sua cotação' },
	},
	{
		path: 'vida',
		loadComponent: () =>
			import(
				'./pages/produtos-insurance/produtos-insurance.component'
			).then((m) => m.ProdutosInsuranceComponent),
		data: { title: 'Seguro Allianz - Vida! Faça sua cotação' },
	},
	{
		path: 'residencia',
		loadComponent: () =>
			import(
				'./pages/produtos-insurance/produtos-insurance.component'
			).then((m) => m.ProdutosInsuranceComponent),
		data: { title: 'Seguro Allianz - Residência! Faça sua cotação' },
	},
	{
		path: 'empresarial',
		loadComponent: () =>
			import(
				'./pages/produtos-insurance/produtos-insurance.component'
			).then((m) => m.ProdutosInsuranceComponent),
		data: { title: 'Seguro Allianz - Empresarial! Faça sua cotação' },
	},
    {
        path: '2ra/residencia',
        redirectTo: 'residencia',
        pathMatch: 'full',
    },
    // LP PREMIUM
    {
        path: 'premium/auto',
        redirectTo: 'auto',
        pathMatch: 'full',
    },
    // INDICA+
    {
        path: 'allianzindica',
        loadComponent: () =>
            import(
                './pages/produtos-insurance/produtos-insurance.component'
            ).then((m) => m.ProdutosInsuranceComponent),
        data: {
            title: 'Indica+ | Allianz'
        },
    },
    // COALA FESTIVAL
    {
        path: 'coala-festival',
        loadComponent: () =>
            import(
                './pages/produtos-insurance/produtos-insurance.component'
            ).then((m) => m.ProdutosInsuranceComponent),
        data: {
            title: 'Coala Festival | Allianz'
        },
    },
    // BLACK FRIDAY REDIRECTS:
    {
        path: 'black-friday/residencia',
        redirectTo: 'residencia',
        pathMatch: 'full',
    },
    {
        path: 'black-friday/vida',
        redirectTo: 'vida',
        pathMatch: 'full'
    },
    {
        path: 'black-friday/empresarial',
        redirectTo: 'empresarial',
        pathMatch: 'full'
    },
	{
		path: 'opin',
		loadComponent: () =>
			import(
				'./pages/opin/opin.component'
			).then((m) => m.Opin),
		data: { title: 'Seguro Allianz - Faça sua cotação' },
	},
	{
		path: 'vida-rappiprime',
		component: ProdutosInsuranceComponent,
		data: { title: 'Seguro Allianz - Vida! Faça sua cotação' },
	},
	{
		path: 'residencia-rappiprime',
		component: ProdutosInsuranceComponent,
		data: { title: 'Seguro Allianz - Residência! Faça sua cotação' },
	},
	{
		path: ':parceiro/:produto',
		component: ProdutosInsuranceComponent,
		data: { title: 'Seguro Allianz - Produto! Faça sua cotação' },
	},
	{
		path: ':parceiro',
		component: ParceirosInsuranceComponent,
		data: { title: 'Seguro Allianz - Parceiro! Faça sua cotação' },
	},
	{
		path: ':parceiro/:produto/:uuid/preview',
		component: ProdutosInsuranceComponent,
		data: { title: 'Seguro Allianz - Produto Preview! Faça sua cotação' },
	},
	{
		path: ':parceiro/:uuid/preview',
		component: ParceirosInsuranceComponent,
		data: { title: 'Seguro Allianz - Parceiro Preview! Faça sua cotação' },
	},
	// {
	// 	path: 'not-found/404/*',
	// 	component: NotFoundComponent,
	// 	data: { title: 'Página não encontrada' },
	// },
	{
		path: '**',
		redirectTo: '/',
		data: { title: 'Seguro Allianz - Faça sua cotação' },
	},
]

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled',
			scrollOffset: [0, 100],
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
